import React, { Component } from "react";
import "./newqrheader.css";

export default class NewQrFooter extends React.Component {
    render() {
        return (
            <>
                <div className="qr_footer_main_wrapper">

                    <div className="row justify-content-start p-0 pt-2">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Kilometer Stand :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ KM</p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start p-0 pt-2">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Auszahlung</p>
                                    <p className="d-flex"><span class="icon_box mt-2">&#9744;</span></p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Reparatur</p>
                                    <p className="d-flex"><span class="icon_box mt-2">&#9744;</span></p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start p-0 pt-2">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Reparaturwerkstatt :</p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Giubiasco</p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>Ort : </p></div>
                                <div className="col-lg-6 col-md-6 col-sm-12"><p>21524-001</p></div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start p-0 pb-2 pt-3">
                        <div className="col-12 qr-bottom-row">
                        </div>
                    </div>
                    <div className="row justify-content-start p-0 pt-3">
                        <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                            <div className="row p-0 pb-2">
                                <div className="col-lg-12 col-md-12 col-sm-12"><p><b>Informationen des Experten :</b></p></div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex align-items-center">
                                        <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>Totalschaden</p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex align-items-center">
                                        <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>Kunde will Fahrzeug behalten</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start align-items-center p-0 pt-2">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="row p-0 pb-2 align-items-center">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="d-flex align-items-center">
                                        <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>Voraussichtlich Totalschaden?</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-start align-items-center pb-3">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p><b>Farbe :</b></p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>uni</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>met</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>perl</p>
                        </div>
                    </div>
                    <div className="row justify-content-start align-items-center pb-3">
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p><b>Fahrzeug Zustand :</b></p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>sehr gepflegt</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>gepflegt</p>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                            <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>ungepflegt</p>
                        </div>
                    </div>
                    <div className="row justify-content-start pt-2">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="d-flex align-items-center">
                                <p className="d-flex"><span class="icon_box mr-1">&#9744;</span>Keine Informationen auf der Rückseite</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-end pt-2">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="text-right">
                                <p>Skizze und Notizen befinden sich auf der Rückseite</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
